<template>
    <div class="activities">
        <div class="grid-container">
            <div class="col p-0 left-aside">
                <div class="member-filter">
                    <form
                            class="search-bar"
                            action="javascript:void(0);"
                    >
                        <button
                                type="submit"
                                class="search-loop"
                        >
                            <i class="atto atto-search-loop"/>
                        </button>
                        <span class="line"/>
                        <input
                                v-model="search"
                                type="search"
                                :placeholder="label.get('search')+'...'"
                        >
                    </form>
                    <button
                            id="sync-now"
                            class="sync-now"
                            :class="{syncing: syncing}"
                            @click="syncNow"
                    >
                        <i class="atto atto-sync-web"/>
                      {{label.get('sync')}}
                    </button>
                    <!--<b-tooltip
                            target="sync-now"
                            placement="bottom"
                            offset="0"
                            triggers="hover"
                    >
                        {{label.get('refresh_data')}}
                    </b-tooltip>-->
                  <b-dropdown
                      ref="dropdown"
                      variant="link"
                      no-caret
                      class="filter-dropdown"
                  >
                    <template slot="button-content">
                      <i
                          class="activity-icon"
                          :class="getStatus(status)"
                      />
                      <span class="filter-title">{{ getLabel(status) }}</span>
                      <i class="atto atto-caret-down-b"/>
                    </template>
                    <b-dropdown-item
                        class="disabled"
                        @click="hideDropdown"
                    >
                      <i class="activity-icon none"/>
                      <p>{{label.get('filter')}}</p>
                      <i class="atto atto-caret-up-b"/>
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="o in statusList"
                        :key="o.id"
                        @click="onStatusChange(o)"
                    >
                      <i
                          class="activity-icon"
                          :class="o.class"
                      />
                      {{ o.label }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="wrapper">
                  <div class="members-list-header">
                    <span class="members">{{label.get('members')}}</span>
                    <span>{{label.get('status')}}</span>
                  </div>
                    <perfect-scrollbar :options="{ wheelPropagation: false}">
                        <div class="all-members-activity">
                            <ul class="member-list">
                                <li
                                        v-for="(activity, idx) in filteredActivities"
                                        :key="idx"
                                >
                                    <a
                                            href="javascript:void(0)"
                                            @click="centerMapToMarker(activity)"
                                    >
                                        <div
                                                class="profile-pic"
                                                :class="[timesheetClass(activity.timesheet), {'no-avatar': activity.avatar === null}]"
                                        >
                                            <!--<i v-if="activity.avatar === null" class="atto atto-avatar"></i>-->
                                            <span
                                                    v-if="activity.avatar === null"
                                                    class="initials"
                                            >
                                              {{ activity.initials }}
                                            </span>
                                            <img
                                                    v-if="activity.avatar != null"
                                                    :src="activity.avatar"
                                                    alt=""
                                                    width="40"
                                                    height="40"
                                            >
                                        </div>
                                        <div
                                                class="name"
                                                :class="timesheetClass(activity.timesheet)"
                                                @click="onMemberActivitySelected($event, activity)"
                                        >
                                            <h4>
                                                {{ activity.name | truncate(30) }}
                                            </h4>
                                            <i class="atto atto-r-arrow-b"/>
                                        </div>
                                        <div
                                                v-if="activity.timesheet"
                                                class="details"
                                        >
                                            <i
                                                    class="activity-icon"
                                                    :class="timesheetClass(activity.timesheet)"
                                            />
                                            <span
                                                    class="status-label"
                                                    :class="timesheetClass(activity.timesheet)"
                                                    :inner-html.prop="activity.timesheet.status_label | truncate(50) | dotSpace"
                                            />
                                        </div>
                                        <div
                                                v-if="!activity.timesheet"
                                                class="details"
                                        >
                                            <i class="activity-icon notActive"/>
                                            <span class="status-label notActive">{{label.get('not_active')}}!</span>
                                        </div>
                                        <button
                                                v-if="activity.timesheet && activity.timesheet.status === 0 && canManageEntries"
                                                :disabled="syncing"
                                                class="atto-btn clockOut"
                                                @click="manualClockInOut($event, activity)"
                                        >{{label.get('clock_out')}}
                                        </button>
                                        <button
                                                v-if="(!activity.timesheet || (activity.timesheet && activity.timesheet.status === 1)) && canManageEntries"
                                                :disabled="syncing"
                                                class="atto-btn clockIn"
                                                @click="manualClockInOut($event, activity)"
                                        >{{label.get('clock_in')}}
                                        </button>
                                        <!--<div class="arrow" v-if="activity.timesheet">
                                                                <i class="atto atto-r-arrow-b"></i>
                                                            </div>-->
                                    </a>
                                </li>
                                <li v-if="filteredActivities.length === 0 && activities.length > 0">
                                    <a href="javascript:void(0)">
                                        <div class="profile-pic no-border"/>
                                        <div>
                                            <p class="no-results">{{label.get('no_team_member_matches_your_search')}}</p>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <ul class="member-list placeholder" v-if="loading">
                                <li v-for="index in 10">
                                    <div class="placeholder-wrapper">
                                        <div class="profile-img"></div>
                                        <div class="placeholders">
                                            <div class="name">
                                                <span class="placeholder-tag loads md"></span>
                                            </div>
                                            <div class="activity">
                                                <div class="bullet-icon">
                                                    <i></i>
                                                </div>
                                                <span class="placeholder-tag loads xs"></span>
                                                <p>
                                                    ·
                                                </p>
                                                <span class="placeholder-tag loads lg"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <a
                                href="#"
                                class="invite"
                                @click="inviteMember"
                                v-if="!loading"
                        >
                            <i class="atto atto-add-more-circled"/>
                            <span>{{label.get('add_new_member')}}</span>
                        </a>
                    </perfect-scrollbar>
                    <div
                            v-if="memberOverlay"
                            class="activity-loader"
                    >
                        <img src="/images/ring-loader.svg">
                    </div>
                </div>
                <member-activity-component
                        v-if="selectedMember"
                        :member="selectedMember"
                />
            </div>
            <div class="col p-0 right-aside">
                <map-component :markers="markers"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ActivityService from "./shared/ActivityService";
    import MapComponent from "./components/MapComponent";
    import MemberActivityComponent from './MemberActivityComponent';

    export default {
        name: "ActivitiesComponent",
        components: {
            MapComponent,
            MemberActivityComponent
        },
        filters: {
            truncate(value, stop) {
                return value.slice(0, stop) + (stop < value.length ? '...' : '');
            },
            dotSpace(value) {
              if (!value) return '';
              const splittedValue = value?.split('·');
              if (splittedValue.length === 2) {
                return `${splittedValue[0].trim()}&nbsp;&nbsp;·&nbsp;&nbsp;${splittedValue[1].trim()}`;
              }
              return value?.trim();
            }
        },
        data() {
            return {
                opened: false,
                search: '',
                status: {
                  id: null,
                  class: 'filter',
                  label: this.label.get('filter')
                },
                info: false,
                memberOverlay: false,
                syncing: false,
                activities: this.$store.state.activities,
                markers: this.$store.state.markers,
                statusList: [
                    {
                        id: null,
                        class: 'none',
                        label: this.label.get('all_members')
                    },
                    {
                        id: 0,
                        class: 'clockedIn',
                        label: this.label.get('clocked_in')
                    },
                    {
                        id: 1,
                        class: 'clockedOut',
                        label: this.label.get('clocked_out')
                    },
                    {
                        id: 4,
                        class: 'onBreak',
                        label: this.label.get('on_break')
                    },
                    {
                        id: -1,
                        class: 'notActive',
                        label: this.label.get('not_active')
                    },
                    {
                        id: 6,
                        class: 'pto',
                        label: this.label.get('time_off')
                    }
                ],
                selectedMember: null,
                isLoading: false
            }
        },
        computed: {
            filteredActivities() {
                return this.activities.filter(item => {
                    if (this.status !== null && this.status.id !== null) {
                        if (this.status.id === -1) {
                            return item.timesheet === null;
                        }
                        return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                            && item.timesheet != null && item.timesheet.status === this.status.id;
                    }
                    return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                });
            },
            loading() {
                return this.isLoading;
            },
            canManageEntries() {
                return this.$store.state.permission.canManageEntries;
            }
        },
        created() {
            this.getActivities();
        },
        mounted() {
            this.$root.$on('reloadActivities', this.onReloadActivities);
            this.$root.$on('closeMemberActivity', this.closeMemberActivity);
            this.$root.$on('hideMemberOverlay', this.hideMemberOverlay);
        },
        beforeDestroy() {
            this.$root.$off('reloadActivities');
            this.$root.$off('closeMemberActivity');
            this.$root.$off('hideMemberOverlay');
        },
        methods: {
            getActivities: function () {
                const _this = this;
                _this.syncing = true;
                if (_this.activities.length === 0) {
                    this.isLoading = true;
                }

                ActivityService.getActivity().then((data) => {
                    _this.activities = data.activities;
                    _this.markers = data.markers;
                    _this.$store.commit('activities', data.activities);
                    _this.$store.commit('markers', data.markers);
                    this.isLoading = false;
                    setTimeout(() => {
                        _this.syncing = false;
                    }, 1700);
                }).catch(error => {
                    this.isLoading = false;
                });
            },

            timesheetClass: function (timesheet) {
                if (timesheet == null) {
                    return "notActive";
                } else if (timesheet.status === 0) {
                    return "clockedIn"
                } else if (timesheet.status === 1) {
                    return "clockedOut"
                } else if (timesheet.status === 4) {
                    return "onBreak"
                } else if (timesheet.status === 6) {
                    return "pto"
                }
            },
            getLabel(opt) {
                if (opt != null && opt.id !== null) {
                    return opt.label;
                }
                return this.label.get('filter');
            },
            getStatus(opt) {
                if (opt != null && opt.id !== null) {
                  return opt.class;
                }
                return 'filter';
            },
            onStatusChange(opt) {
                this.status = opt;
                this.opened = false;
            },
            toggle() {
                this.opened = !this.opened
            },

            hideDropdown() {
                this.$refs.dropdown.hide(true);
            },
            syncNow() {
                this.getActivities();
            },
            manualClockInOut(event, activity) {
                event.preventDefault();
                event.stopPropagation();
                if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
                    this.$root.$emit('noSubscription');
                    return;
                }
                this.$root.$emit('showManualClockInOut', activity);
            },
            centerMapToMarker(activity) {
                let userMarker = this.markers.filter((item) => {
                    return item.user_id === activity.id;
                });

                if (userMarker.length > 0) {
                    this.$root.$emit('centerMap', userMarker[0], false);
                } else {
                    this.$root.$emit('closeAllMarkers');
                }
            },
            onReloadActivities: function () {
                this.getActivities();
            },
            inviteMember: function () {
                this.$root.$emit('showInviteMembers');
            },
            onMemberActivitySelected(event, activity) {
                const userId = activity.id;
                if (activity.timesheet === null) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                const member = this.$store.state.members.find((item) => {
                    return item.id === userId;
                });
                const marker = this.markers.find((item) => item.user_id === userId);
                if (member !== undefined && member !== null) {
                    this.markers = [];
                    if (marker !== undefined && marker !== null && marker.latitude !== null) {
                        this.markers = [marker];
                    }
                    this.memberOverlay = true;
                    this.selectedMember = member;
                }
            },
            closeMemberActivity() {
                this.selectedMember = null;
                this.markers = this.$store.state.markers;
            },
            hideMemberOverlay() {
                this.memberOverlay = false;
            }

        }
    }
</script>
<style lang="scss">

  .activities {
    background-color: #fff;
  }

    .member-filter {
        padding: 16px;
        border-bottom: 1px solid $atto-light-grey;
        display: flex;
        flex-direction: row;
        border-right: 1px solid $atto-light-grey;
        align-items: center;
        height: 60px;

        form {
            display: inline-flex;
            padding: 7px 11px;
            background-color: transparent;
            align-items: center;
            height: auto;
            min-width: 215px;
            max-width: 215px;
            width: 24%;
            margin-right: 20px;
            @include base-transition(ease all 0.15s);

            button.search-loop {
                width: 24px;
                height: 24px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                margin-right: 13px;
                border: 0;
                padding: 0;
                background: transparent;

                i {
                    @include base-transition(ease all 0.15s);
                    font-size: 18px;
                    color: $atto-dark-grey;
                }
            }

            input[type=search] {
                display: inline-flex;
                flex-grow: 1;
                border: 0;
                padding: 0;
                box-shadow: none;
                background-color: transparent;
                font-size: 0.875rem;
                line-height: 1.5rem;
                color: $atto-font-color;
                font-family: $roboto-font;

                ::-webkit-input-placeholder,
                ::-moz-placeholder,
                :-ms-input-placeholder,
                :-moz-placeholder {
                    color: $atto-not-active;
                    opacity: 1;
                }
                &:focus {
                    outline: 0;
                }
            }

            &:focus-within {
               /* border: 1px solid $atto-dark-grey;*/

                button.search-loop {
                    i {
                        color: $atto-not-active;
                    }
                }
            }
        }

        .b-dropdown {

            .dropdown-toggle {
                display: inline-flex;
                align-items: center;
                background-color: #f7f7f7;
                padding: 3px 8px 3px 4px;
                height: 30px;
                width: 196px;
                position: relative;
                margin-left: 16px;
                cursor: pointer;
                border-radius: 0;
                @include base-transition(ease all 0.15s);

                span.filter-title {
                    color: $atto-font-color;
                    font: $roboto-regular 0.8125rem/1.25rem $roboto-font;
                }
              .atto-caret-down-b{
                display: flex;
                margin-left: auto;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                font-size: 9px;
                color: #C7C7C7;
              }

                &:hover {
                    text-decoration: none;
                    /*border-color: #C7C7C7;*/
                }

                &:focus,
                &:active,
                &:active:focus {
                    text-decoration: none;
                }


                i.activity-icon {
                    width: 4px;
                    height: 4px;
                    margin: 0 10px;

                  &.filter{
                    width: 24px;
                    height: 24px;
                    font-size: 11px;
                    color: $atto-font-color;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0;
                    border-radius: 0;
                    &:before{
                      display: inline-flex;
                      content: "\E93C";
                      font-family: 'attotime';
                      speak: none;
                      font-style: normal;
                      font-weight: normal;
                      font-variant: normal;
                      text-transform: none;
                      line-height: 1;
                      -webkit-font-smoothing: antialiased;
                      -moz-osx-font-smoothing: grayscale;
                    }
                  }
                }


            }

            .dropdown-menu {
                border: 0;
                position: absolute;
                top: -8px;
                left: 0;
                width: 196px;
                box-shadow:  0 0 6px 0 rgba(38,38,38,0.25);;
                background-color: #fff;
                border-radius: 0;
                padding: 0 0 8px 0;
                margin: -43px 0 0 1px;

                li.disabled {
                  height: 56px;
                    a {
                        display: flex;
                        flex-direction: row;
                        padding: 16px 8px;
                        align-items: center;
                        border-bottom: 2px solid #efefef;

                        p {
                            flex-grow: 1;
                            margin-bottom: 0;
                            font: $roboto-regular 0.875rem/1.25rem $roboto-font;
                            color: $atto-font-color;
                        }
                        .atto-caret-up-b{
                          display: flex;
                          margin-left: auto;
                          align-items: center;
                          justify-content: center;
                          width: 24px;
                          height: 24px;
                          font-size: 9px;
                          color: #C7C7C7;
                        }

                        &:hover {
                            background-color: transparent;
                        }
                      i.activity-icon{
                        &.none{
                          margin: 0 7px;
                        }
                      }
                    }

                }

                li {
                    display: flex;
                    padding: 0;
                    height: 40px;

                    a {
                        padding: 8px 4px;
                        font: $roboto-regular 0.875rem/1.25rem $roboto-font;
                        color: $atto-font-color;
                        width: 100%;
                        cursor: pointer;
                        display: flex;
                        align-items: center;

                        &:hover {
                            background-color: #F7F7F7;
                        }

                        i.activity-icon {
                            width: 6px;
                            height: 6px;
                            margin: 0 9px;
                        }
                    }
                  &:nth-child(2){
                    height: 48px;
                    a{
                      padding-top: 16px;
                    }
                  }
                }
            }

            i.atto-u-arrow-b,
            i.atto-d-arrow-b {
                font-size: 12px;
                color: #c9c9c9;
                margin-left: auto;
                margin-right: 8px;
            }

            i.atto-d-arrow-b {
                margin-right: 7px;
            }

        }

        button.sync-now {
            width: 67px;
            height: 30px;
            /*margin-left: 6px;*/
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            font: $roboto-medium 0.8125rem/0.9375rem $roboto-font;
            color: $atto-font-color;
            text-transform: capitalize;
            @include base-transition(ease all 0.15s);

          i.atto-sync-web{
            width: 24px;
            height: 24px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 3px;

            &:before{
              color: #000000;
            }
          }

            &.syncing {
                /*border: 1px solid #C7C7C7;*/
                i {
                    -webkit-animation: rotating 0.6s linear infinite;
                    -moz-animation: rotating 0.6s linear infinite;
                    -ms-animation: rotating 0.6s linear infinite;
                    -o-animation: rotating 0.6s linear infinite;
                    animation: rotating 0.6s linear infinite;
                }

            }

            &:hover {
                border-color: #C7C7C7;
            }
        }
    }
    .filter-dropdown{
      margin-left: auto;
    }
    i.activity-icon {
        display: inline-flex;
        height: 6px;
        width: 6px;
        border-radius: 100%;
        margin: 0 9px;

        &.clockedIn {
            background-color: $atto-light-green;
        }

        &.clockedOut {
            background-color: $atto-red;
        }

        &.onBreak {
            background-color: $atto-orange;
        }

        &.pto {
            background-color: $atto-not-active;
        }

        &.notActive {
            background-color: $atto-dark-grey;
        }
    }

    .activity-sort {
        display: inline-flex;
        align-items: center;
        background-color: #fafafa;
        border: 1px solid $atto-light-grey;
        padding: 8px;
        width: 200px;
        position: relative;
        margin-left: 16px;

        cursor: pointer;

        i.activity-icon {
            margin: 0 9px;
        }

        .activities-filters {
            display: flex;
            width: 100%;

            i.atto-u-arrow-b,
            i.atto-d-arrow-b {
                font-size: 12px;
                color: #c9c9c9;
                margin-left: auto;
                margin-right: 8px;
            }

            .selected-activity {
                display: inline-flex;
                align-items: center;
                width: 100%;

                span.selected-options {
                    color: #262626;
                    font-family: $roboto-font;
                    font-weight: 500;
                    font-size: 0.875rem;
                    line-height: 1.2rem;
                    display: inline-flex;
                    flex-grow: 1;
                }
            }

            .dropdown-options {
                position: absolute;
                top: -8px;
                left: 0;
                width: 100%;
                box-shadow: 0 0 10px 0 #C7C7C7;
                background-color: #fff;
                z-index: 1001;

                .title {
                    padding: 16px 8px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    border-bottom: 2px solid #efefef;

                    p {
                        flex-grow: 1;
                        margin-bottom: 0;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        font-family: $roboto-font;
                        color: $atto-font-color;
                        font-weight: 500;
                    }

                }

                .activity-list {
                    ul {
                        padding: 8px 0;
                    }

                    li {
                        display: inline-flex;
                        padding: 8px;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        font-family: $roboto-font;
                        color: $atto-font-color;
                        font-weight: 500;
                        width: 100%;
                        align-items: center;
                        cursor: pointer;

                        &:hover {
                            background-color: #F7F7F7;
                        }
                    }
                }
            }

            &.opened {
                .dropdown-options {
                    display: block;
                }
            }

            .select_overlay {
                position: fixed;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                z-index: 1000;
            }
        }

    }
    .members-list-header{
      height: 35px;
      width: 100%;
      display: flex;
      align-items: center;
      background-color: #F7F7F7;
      border-bottom: 1px solid #EFEFEF;
      padding: 12px 64px;

      span{
        text-transform: uppercase;
        color: #666666;
        font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
        letter-spacing: 0.5px;

        &.members{
          min-width: 200px;
          max-width: 200px;
          width: 24.7%;
          margin-right: 20px;
        }
      }
    }
    .member-list {
        li {
            position: relative;
            border-bottom: 1px solid $atto-light-grey;
            border-right: 1px solid $atto-light-grey;
            height: 52px;
            display: flex;
            align-items: center;

            a {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                padding: 8px 16px;
                height: 51px;
                width: 100%;

                &:hover {
                    color: $atto-font-color;
                    background-color: #FAFAFA;

                    .arrow {
                        i {
                            color: #262626;
                        }
                    }
                }
            }

            .profile-pic {
                min-width: 36px;
                max-width: 36px;
                width: 36px;
                height: 36px;
                border-radius: 100%;
                margin-right: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                align-content: center;

                img {
                    border-radius: 100%;
                }

                i.atto-avatar {
                    font-size: 36px;
                }
            }

            .name {
                display: inline-flex;
                width: 22.2222%;
                min-width: 185px;
                max-width: 185px;
                margin-right: 20px;

                h4 {
                    font-family: $roboto-font;
                    font-weight: 400;
                    font-size: 1rem;
                    position: relative;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }


            }

            .details {
                display: flex;
                align-items: center;
                width: 50%;
                min-width: 260px;

                * {
                    display: inline-flex;
                }

                i.activity-icon {
                    margin-left: 0;
                    width: 6px;
                    height: 6px;
                    -webkit-border-radius: 6px;
                    -moz-border-radius: 6px;
                    border-radius: 6px;
                }

                span.status-label {
                    display: inline-block;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;
                    width: 100%;
                    /*&:not(.not-active){*/
                    /*word-spacing: 2px;*/
                    /*}*/
                }

                .activity-info,
                .status-label {
                    font-size: 0.9375rem;
                    font-family: $roboto-font;
                    font-weight: $roboto-regular;

                    &.notActive {
                        color: #666666;
                    }
                }

                .activity-info::before {
                    content: '';
                }
            }

            .arrow {
                margin-left: auto;

                i {
                    font-size: 16px;
                    color: #C7C7C7;
                }
            }

            .clockOut,
            .clockIn {
                display: none;
                cursor: pointer;
                margin-left: auto;
                text-transform: uppercase;
            }

            &:hover {
                .clockIn,
                .clockOut {
                    display: inline-flex;
                }
              .details{
                min-width: 190px;
              }
            }

            p.no-results {
                font-family: $roboto-font;
                font-weight: 400;
                font-size: 1rem;
                line-height: 1.5rem;
                color: $atto-not-active;
                margin-bottom: 0;

            }
        }

        &.placeholder {
            li {
                > div.placeholder-wrapper {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    padding: 16px 20px;
                    .profile-img{
                        width: 36px;
                        height: 36px;
                        display: inline-flex;
                        background: url('~@assets/images/profile-avatar.png') no-repeat center;
                        -webkit-background-size: contain;
                        background-size: contain;
                        margin-right: 20px;
                    }

                    p{
                        margin-bottom: 0;
                        width: 24px;
                        text-align: center;
                    }

                    .placeholders{
                        display: flex;
                        flex-direction: row;
                        flex-grow: 1;

                        .name{
                            margin-right: 0;
                        }

                        .activity{
                            flex-grow: 1;
                            display: inline-flex;
                            align-items: center;
                        }
                    }

                    .bullet-icon{
                        width: 24px;
                        height: 24px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;

                        i{
                            width: 8px;
                            height: 8px;
                            background-color: #c7c7c7;
                            border-radius: 8px;
                        }
                    }

                    .placeholder-tag{
                        height: 24px;
                        border-radius: 4px;
                        background-color: #efefef;

                        &.xs{
                            width: 56px;
                        }
                        &.sm{
                            width: 72px;
                        }
                        &.md{
                            width: 96px;
                        }
                        &.lg{
                            width: 132px;
                        }
                        &.xl{
                            width: 164px;
                        }
                        &.xxl{
                            width: 212px;
                        }
                    }
                }
            }
        }
    }

    .all-members-activity {
        .member-list {
            li {
                .profile-pic {

                    border-radius: 100%;
                    width: 36px;
                    min-width: 36px;
                    max-width: 36px;
                    height: 36px;

                    span.initials {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        font-weight: 400;
                        font-family: "Roboto", sans-serif;
                        color: #999;
                        background-color: #efefef;
                        border-radius: 100%;
                        width: 100%;
                        height: 100%;
                        text-transform: uppercase;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                    }

                    &.no-border {
                        border: none;
                    }
                }

                .name {
                    height: 40px;
                    align-items: center;

                    h4 {
                        font-weight: $roboto-regular;
                        font-size: 0.9375rem;
                    }

                    i {
                        display: none;
                    }

                    &.clockedIn,
                    &.clockedOut,
                    &.onBreak {
                        /*h4 {
                            &:after {
                                content: '';
                                position: absolute;
                                bottom: 0px;
                                left: 0;
                                width: 100%;
                                height: 1px;
                                background-color: transparent;
                                @include base-transition(ease all 0.1s);
                            }
                        }*/


                        i {
                            font-size: 12px;
                            color: $atto-font-color;
                            width: 24px;
                            height: 24px;
                            display: none;
                            align-items: center;
                            justify-content: center;
                            margin-left: 2px;
                            font-weight: bold;
                        }

                        &:hover {
                            h4 {
                                &:after {
                                    background-color: $atto-font-color;
                                }
                            }
                        }
                    }
                }

              /*  &:hover {
                    .name {
                        &.clockedIn,
                        &.clockedOut,
                        &.onBreak {
                            i {
                                display: inline-flex;
                            }
                        }
                    }
                }*/
            }
        }
    }

    .ps {

        .ps__rail-y {
            width: 16px;
            opacity: 0;

            &:hover {
                background-color: transparent;

                .ps__thumb-y {
                    width: 8px;
                    background-color: rgba(239, 239, 239, 1);
                }
            }

            &.ps--clicking {
                background-color: transparent;

                .ps__thumb-y {
                    background-color: rgba(239, 239, 239, 1);
                    width: 8px;
                }
            }
        }

        .ps__thumb-y {
            right: 4px;
            width: 8px;
            opacity: 1;
            background-color: rgba(239, 239, 239, 0.5);
        }

        &:hover {
            .ps__rail-y {
                opacity: 1;
            }
        }

    }

    button.invite,
    a.invite {
        padding: 21px 0 19px;
        display: flex;
        align-items: center;
        height: 52px;
        -webkit-transition: ease all 0.30s;
        -moz-transition: ease all 0.30s;
        -ms-transition: ease all 0.30s;
        -o-transition: ease all 0.30s;
        transition: ease all 0.30s;
      /*  border-bottom: 1px solid $atto-light-grey;*/

        i.atto {
            margin: 0 18px 0 22px;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
            line-height: 1.25rem;
            color: $atto-green;
        }

        span {
            color: $atto-font-color;
            font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
            -webkit-transition: ease all 0.30s;
            -moz-transition: ease all 0.30s;
            -ms-transition: ease all 0.30s;
            -o-transition: ease all 0.30s;
            transition: ease all 0.30s;
        }

        &:hover {
            span {
                color: $atto-green;
            }
        }
    }

    .activity-loader {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.5);
    }
</style>